"use strict";

var _classCallCheck = require("/home/site/repository/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/site/repository/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/site/repository/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/site/repository/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _get = require("/home/site/repository/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _inherits = require("/home/site/repository/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _require = require("../../utils"),
    mixin = _require.mixin;

var DOMTokenList = require("../generated/DOMTokenList");

var HTMLElementImpl = require("./HTMLElement-impl").implementation;

var HTMLHyperlinkElementUtilsImpl = require("./HTMLHyperlinkElementUtils-impl").implementation;

var HTMLAnchorElementImpl =
/*#__PURE__*/
function (_HTMLElementImpl) {
  _inherits(HTMLAnchorElementImpl, _HTMLElementImpl);

  function HTMLAnchorElementImpl(args, privateData) {
    var _this;

    _classCallCheck(this, HTMLAnchorElementImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(HTMLAnchorElementImpl).call(this, args, privateData));

    _this._htmlHyperlinkElementUtilsSetup();

    _this._hasActivationBehavior = true;
    return _this;
  }

  _createClass(HTMLAnchorElementImpl, [{
    key: "_activationBehavior",
    value: function _activationBehavior() {
      this._followAHyperlink();
    }
  }, {
    key: "_attrModified",
    value: function _attrModified(name, value, oldValue) {
      _get(_getPrototypeOf(HTMLAnchorElementImpl.prototype), "_attrModified", this).call(this, name, value, oldValue);

      if (name === "rel" && this._relList !== undefined) {
        this._relList.attrModified();
      }
    }
  }, {
    key: "relList",
    get: function get() {
      if (this._relList === undefined) {
        this._relList = DOMTokenList.createImpl([], {
          element: this,
          attributeLocalName: "rel"
        });
      }

      return this._relList;
    }
  }, {
    key: "text",
    get: function get() {
      return this.textContent;
    },
    set: function set(v) {
      this.textContent = v;
    }
  }]);

  return HTMLAnchorElementImpl;
}(HTMLElementImpl);

mixin(HTMLAnchorElementImpl.prototype, HTMLHyperlinkElementUtilsImpl.prototype);
module.exports = {
  implementation: HTMLAnchorElementImpl
};